<template>
  <multiselect v-model="modelValue"
               label="name"
               track-by="name"
               :options="listOptions"
               :allow-empty="true"
               :deselect-label="deselectLabel"
               :select-label="selectLabel"
               :selected-label="selectedLabel"
               :placeholder="placeholder">
    <template slot="noOptions">
      {{ noOptionsText }}
    </template>
    <template slot="noResult">
      {{ noResultText }}
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },

  props: {
    deselectLabel: {
      type: String,
      default: ''
    },

    includeBlank: {
      type: String,
      default: 'Selecione'
    },

    noOptionsText: {
      type: String,
      default: 'Nenhum item encontrado.'
    },

    noResultText: {
      type: String,
      default: 'A lista está vazia.'
    },

    options: {
      type: Array,
      default: () => []
    },

    placeholder: {
      type: String,
      default: 'Selecione'
    },

    selectLabel: {
      type: String,
      default: ''
    },

    selectedLabel: {
      type: String,
      default: 'Selecionado'
    },

    url: {
      default: null,
      validator: prop => typeof prop === 'string' || prop === null
    },

    value: {
      required: true,
      validator: prop => typeof prop === 'string' || typeof prop === 'number' || prop === null
    }
  },

  data () {
    return {
      modelValue: null,
      listOptions: []
    }
  },

  computed: {
    blankOption() {
      return { name: this.includeBlank, id: null }
    }
  },

  watch: {
    modelValue (newVal, oldVal) {
      if (newVal === undefined || oldVal === undefined ) return
      if (newVal === oldVal) return
      if (newVal.id === this.value) return

      if (newVal) {
        this.$emit('input', newVal.id)
      } else {
        this.$emit('input', null)
      }
    },

    value (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fillModelValueWith({ value: newVal })
      }
    },
  },

  mounted() {
    if (this.url) {
      this.fetchOptions()
    } else {
      this.listOptions = this.options
      this.$nextTick(() => this.fillModelValueWith(this))
    }
  },

  methods: {
    fetchOptions() {
      this.axios.get(this.url).then(({ data }) => {
        let items = this.formatItems(data)
        this.listOptions = [this.blankOption, ...items]
      }).catch(() => {
        this.listOptions = []
      }).finally(() => {
        this.fillModelValueWith(this)
      })
    },

    fillModelValueWith({ value }) {
      this.modelValue = this.listOptions.find(item => item.id === value)
    },

    formatItems(items) {
      return items.map((item) => {
        let name = item.name || item.short
        return { name: name, id: item.id }
      })
    }
  }
}
</script>
